import React, { Component } from 'react';

class Dashboard extends Component {
  render() {
    return <h1 className="hide">Hello</h1>;
  }
}
export default Dashboard;
